// Human-operated demo identities. Production and development use separate
// Supabase Auth projects, so the same two email addresses have different UUIDs
// in each environment. Seed visibility is ID-based: email aliases are not an
// authorization boundary and must never grant demo access on their own.
export const DEMO_ACCOUNT_IDS = [
  // compaire-prod
  "374363bc-c568-4b26-822a-af65dce01d0b",
  "8e74d3fe-76f9-4072-87f2-2a02170c135c",
  // compaire-dev
  "d7b2dfb8-25e3-4709-a021-1347da919e42",
  "912a9e03-2b1e-471f-8a1d-36c21fce19e5",
] as const;

// Non-human exception required by the authenticated dev smoke suite. Keeping
// it separate prevents UI code from treating automation as a human demo user.
export const AUTOMATION_SEED_VIEWER_IDS = [
  "f2166702-ad57-4fe8-888d-6616543fdeef",
] as const;

export const SEED_VIEWER_IDS = [
  ...DEMO_ACCOUNT_IDS,
  ...AUTOMATION_SEED_VIEWER_IDS,
] as const;

export const isExplicitDemoAccount = (userId?: string | null) =>
  !!userId && DEMO_ACCOUNT_IDS.includes(userId as (typeof DEMO_ACCOUNT_IDS)[number]);

export const isExplicitSeedViewer = (userId?: string | null) =>
  !!userId && SEED_VIEWER_IDS.includes(userId as (typeof SEED_VIEWER_IDS)[number]);

export const demoProfileOrFilter = [
  ...SEED_VIEWER_IDS.map((userId) => `user_id.eq.${userId}`),
].join(",");
